import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { renderSanitizedHtml } from '@whitbread-eos/utils';
import React, { useMemo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Newsletter(_ref) {
  var data = _ref.data,
    routerPush = _ref.routerPush;
  var hasNewsLetter = useMemo(() => {
    var newsletterSignup = data.newsletterSignup;
    return hasNewsLetterSignupContent(newsletterSignup);
  }, [data]);
  if (!hasNewsLetter) {
    return null;
  }
  var _data$newsletterSignu = data.newsletterSignup,
    introViewTitle = _data$newsletterSignu.introViewTitle,
    introViewText = _data$newsletterSignu.introViewText,
    signUpButtonText = _data$newsletterSignu.signUpButtonText;
  return _jsx(Flex, _objectSpread(_objectSpread({}, newsletterWrapperStyle), {}, {
    children: _jsx(Box, {
      p: "lg",
      children: _jsxs(Flex, {
        direction: "column",
        children: [_jsx(Text, _objectSpread(_objectSpread({}, newsletterTitleStyle), {}, {
          "data-testid": 'newsletter-title',
          children: introViewTitle
        })), _jsx(Box, _objectSpread(_objectSpread({}, newsletterDescriptionStyle), {}, {
          "data-testid": 'newsletter-description',
          children: renderSanitizedHtml(introViewText)
        })), _jsx(Button, _objectSpread(_objectSpread({}, newsletterButtonStyle), {}, {
          "data-testid": 'newsletter-link',
          onClick: () => {
            routerPush('https://www.premierinn.com/de/de/presse.html');
          },
          children: signUpButtonText
        }))]
      })
    })
  }));
}
function hasNewsLetterSignupContent(newsletterSignup) {
  if (!newsletterSignup) {
    return false;
  }
  return Object.values(newsletterSignup).every(value => {
    if (value !== null) {
      return true;
    }
    return false;
  });
}
var newsletterWrapperStyle = {
  direction: 'column',
  w: 'full',
  bgColor: 'lightPurple'
};
var newsletterTitleStyle = {
  fontSize: 'md',
  color: 'baseWhite',
  fontWeight: 'medium'
};
var newsletterDescriptionStyle = {
  fontSize: 'sm',
  color: 'baseWhite',
  fontWeight: 'normal'
};
var newsletterButtonStyle = {
  size: 'full',
  variant: 'tertiary',
  mt: 'lg'
};